import { createContext } from "react";

export const ThemeConText = createContext({});